import axios from "axios";
const qs = require('qs');
// const url = 'http://localhost:8082/api';
// const url ='https://erp.yichitong.com/admin-api';
const url ='http://101.200.183.111:30000/api';

/**
 * @description: 
 * @param {*} data
 * @return {*}
 * @author: zhangben
 */
export function queryMenu(data) {
  return axios.post(url+'/yctOfficialInfoClass/tree',data)
}

export function queryClassDetail(classId) {
  return axios.get(url+'/api/banner/bannerList')
}


export function queryBanner() {
  return axios.get(url+'/banner/bannerList')
}

export function queryNew(data) {
  // 将对象转换为查询字符串
  const queryString = qs.stringify(data);
  return axios.get(url+'/news/list?'+queryString)
}
export function queryNewDetail(id) {
  return axios.get(url+'/news/detail?id='+id)
}

export function queryYiBoDetail(id) {
  return axios.get(url+'/yibo/detail?id='+id)
}

export function queryProduct(data) {
  // 将对象转换为查询字符串
  const queryString = qs.stringify(data);
  return axios.get(url+'/product/productList?'+queryString)
}
export function queryProductDetail(id) {
  return axios.get(url+'/product/detail?id='+id)
}

export function queryGcal(data) {
  // 将对象转换为查询字符串
  const queryString = qs.stringify(data);
  return axios.get(url+'/gcal/gcalList?'+queryString)
}

export function queryGcalList(data) {
  // 将对象转换为查询字符串
  const queryString = qs.stringify(data);
  return axios.get(url+'/gcal/list?'+queryString)
}
export function queryGcalDetail(id) {
  return axios.get(url+'/gcal/detail?id='+id)
}

export function querySjList(data) {
  const queryString = qs.stringify(data);
  return axios.get(url+'/sj/list?'+queryString)
}

export function querySjClassDetail(id) {
  return axios.get(url+'/sjclass/detail?id='+id)
}


export function queryZpList(data) {
  const queryString = qs.stringify(data);
  return axios.get(url+'/zpjob/list?'+queryString)
}

export function queryZpListDetai(id) {
  return axios.get(url+'/zpjob/detail?id='+id)
}

export function queryYpAdd(data) {
  return axios.post(url+'/ypjob/add',data)
}


export function queryZxfw(data) {
  // 将对象转换为查询字符串
  const queryString = qs.stringify(data);
  return axios.get(url+'/zxfw/list?'+queryString)
}
export function queryZxfwDetail(id) {
  return axios.get(url+'/zxfw/detail?id='+id)
}

// export function queryNews(data) {
//   // 将对象转换为查询字符串
//   const queryString = qs.stringify(data);
//   return axios.get(url+'/news/list?'+queryString)
// }
  
export default{
  
}


// WEBPACK FOOTER //
// ./src/api/api.js